import { Toaster as Sonner, toast } from 'sonner'

/**
 * Spec 07 · Toast / flash.
 *
 * Default is the ink bar with an accent dot and a close glyph in
 * ink-muted, at "raised" elevation. Errors invert to surface with a
 * destructive hairline and destructive text. z 80 — above everything.
 */
function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      gap={8}
      offset={16}
      duration={4000}
      icons={{
        success: <span className="size-1.5 shrink-0 rounded-full bg-signal" />,
        error: <span className="size-1.5 shrink-0 rounded-full bg-destructive" />,
        info: <span className="size-1.5 shrink-0 rounded-full bg-signal" />,
        warning: <span className="size-1.5 shrink-0 rounded-full bg-signal" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-center gap-3 rounded-md px-[15px] py-[13px] text-[12px] shadow-raised bg-ink text-ink-inverse',
          error: 'bg-surface text-destructive border border-destructive shadow-none',
          title: 'flex-1 leading-snug',
          description: 'text-ink-faint',
          closeButton: 'text-ink-muted hover:text-ink-inverse',
          actionButton:
            'rounded-full bg-ink px-3.5 py-2 text-[13px] font-semibold text-ink-inverse',
        },
      }}
      style={{ zIndex: 80 }}
    />
  )
}

export { Toaster, toast }
